<template lang="pug">
.admin-account-update
  v-card
      v-card-title.headline 修改帳號
      v-card-text
        account-update-form(
          ref="form"
          :user="user")
        .caption.error--text(xs12)
          span {{ message }}
      v-card-actions
        v-layout(
          align-center
          justify-end)
          v-btn(
            :loading="loading"
            flat
            outline
            color="indigo"
            @click="submit") 送出
</template>

<script>
import AccountUpdateForm from "@/components/forms/AccountUpdateForm.vue";
import errorParser from "@/utils/error";

export default {
  name: "AdminAccountUpdate",
  components: {
    AccountUpdateForm
  },
  data() {
    return {
      message: "",
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      try {
        const res = await this.$refs.form.submit();
        console.log(res);
        if (!res) {
          return (this.loading = false);
        }
      } catch (e) {
        this.message = errorParser(e);
        this.loading = false;
      }

      this.loading = false;
    }
  }
};
</script>
